import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';

export type Template = {
  id?: number;
  name: string;
  organization_id?: string;
  template_docx: File | null;
  template_example: File | null;
  template_type?: string;
  prompt: string;
  type?: string;
};

export type ExportTemplateResponse = BaseResponse<Template>;

const fetchTemplate = async (
  customerId: number,
  templateId: number
): Promise<ExportTemplateResponse> => {
  const { data } = await Axios.get(
    `${GET_URL(customerId.toString(), templateId.toString()).exportTemplateBo}`
  );
  return data;
};

export const useGetExportBoTemplate = (
  customerId: number,
  templateId: number,
  options?: UseQueryOptions<
    ExportTemplateResponse,
    AxiosError<BaseError>,
    ExportTemplateResponse
  >
) => {
  return useQuery<ExportTemplateResponse, AxiosError<BaseError>>(
    QueryKeys.exportTempalte(templateId),
    () => fetchTemplate(customerId, templateId),
    {
      ...options,
      enabled: Boolean(customerId && templateId),
      useErrorBoundary: false
    }
  );
};
